<template>
  <div class="flexing flex-col w-full">
    <div class="w-full p-6 space-y-6">
      <h1 class="text-texts-standard-danger font-medium text-36">
        {{ $t('homepage.linkExpired') }}
      </h1>
      <p class="text-texts-standard-default text-28 font-medium py-8">
        {{ $t('homepage.requestAgain') }}
      </p>
      <app-button type="submit" btn-type="confirm" @click="$emit('continue')">
        {{ $t('homepage.continue') }}
        <component-loading class="absolute inset-0" :is-loading="isLoading" />
      </app-button>
    </div>
  </div>
</template>

<script lang="ts">
import ComponentLoading from '../GlobalComponents/ComponentLoading.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  components: {
    ComponentLoading,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['continue'],
})
</script>
